<template>
  <div class="row">
    <div class="col-12 mb-3">
      <em class="fas fa-arrow-from-right text-orange mr-1" />
      <span class="color-gray-7 font-weight-bold font-16">
        Raz&oacute;n para Solicitud de Reemplazo
      </span>
    </div>
    <div class="col-12 col-md-7 mb-3 mb-md-0">
      <validation-observer ref="contractDocumentReplacementObserver">
        <validation-provider
          v-slot="{ errors }"
          name="Archivo"
          rules="required"
        >
          <custom-input
            v-model="razonByReplaceDocument"
            custom-error-msg="Este campo es requerido para continuar con el proceso."
            :error="errors[0]"
            label="Razón:"
            maxlength="3000"
            type="text"
          />
        </validation-provider>
      </validation-observer>
    </div>
    <div class="col-12 col-md-5 d-flex justify-content-end align-items-end">
      <action-button
        id="modal-btn-cancelar"
        i="fas fa-times-circle"
        variant="outline-danger mr-2"
        @click="handleCancel"
      >
        Cancelar
      </action-button>

      <action-button
        i="fa fa-save"
        variant="success px-3"
        @click="handleConfirm"
      >
        Guardar
      </action-button>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import CustomInput from 'CustomInput';

export default {
  name: 'ContractDocumentReplacement',
  components: {
    ActionButton,
    CustomInput,
  },
  data: () => ({
    razonByReplaceDocument: '',
  }),
  methods: {
    handleCancel() {
      this.$emit('cancel');
    },
    async handleConfirm() {
      const isValid = await this.$refs.contractDocumentReplacementObserver.validate();
      if (!isValid) {
        return;
      }

      this.$emit('confirm', this.razonByReplaceDocument);
    },
  },
};
</script>

<style scoped lang="scss">
.date-container {
  text-align: end;
}

.comment__container {
  background-color: white;
  border-radius: 3px;
}

::v-deep .timeline__content::before {
  height: calc(100% + 30px) !important;
  top: 15px !important;
}

::v-deep .timeline__content::after {
  top: 15px !important;
}

::v-deep .custom-time-line {
  .timeline__content--inner {
    padding: unset !important;
  }
}
</style>
